__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "host";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@azure/msal-browser", "2.30.0", function() { return function() { return __webpack_require__(51599); }; }, 1);
			register("@azure/msal-react", "1.4.9", function() { return function() { return __webpack_require__(83607); }; }, 1);
			register("@emotion/react", "11.14.0", function() { return function() { return __webpack_require__(67865); }; }, 1);
			register("@emotion/react", "11.9.0", function() { return function() { return __webpack_require__(67909); }; }, 1);
			register("@emotion/styled", "11.14.0", function() { return function() { return __webpack_require__(10789); }; }, 1);
			register("@emotion/styled", "11.6.0", function() { return function() { return __webpack_require__(24984); }; }, 1);
			register("@fullstory/browser", "1.6.2", function() { return function() { return __webpack_require__(75045); }; }, 1);
			register("@horizon/divider", "1.1.0", function() { return function() { return __webpack_require__(57770); }; }, 1);
			register("@horizon/heading", "2.0.3", function() { return function() { return __webpack_require__(22924); }; }, 1);
			register("@horizon/icon-button", "2.1.0", function() { return function() { return __webpack_require__(1783); }; }, 1);
			register("@horizon/inline", "1.1.0", function() { return function() { return __webpack_require__(42825); }; }, 1);
			register("@horizon/inline", "2.0.2", function() { return function() { return __webpack_require__(6261); }; }, 1);
			register("@horizon/input", "1.1.4", function() { return function() { return __webpack_require__(30843); }; }, 1);
			register("@horizon/stack", "1.1.0", function() { return function() { return __webpack_require__(33578); }; }, 1);
			register("@horizon/text", "1.1.1", function() { return function() { return __webpack_require__(19783); }; }, 1);
			register("@kmx/mui-resources", "0.4.2", function() { return function() { return __webpack_require__(90675); }; }, 1);
			register("@microsoft/applicationinsights-core-js", "2.8.13", function() { return function() { return __webpack_require__(27367); }; }, 1);
			register("@microsoft/applicationinsights-web", "2.8.13", function() { return function() { return __webpack_require__(30634); }; }, 1);
			register("@mui/material", "6.4.4", function() { return function() { return __webpack_require__(62940); }; }, 1);
			register("@mui/material", "6.4.4", function() { return function() { return __webpack_require__(78554); }; }, 1);
			register("@mui/system", "6.4.8", function() { return function() { return __webpack_require__(70679); }; }, 1);
			register("@mui/system", "6.4.8", function() { return function() { return __webpack_require__(48601); }; }, 1);
			register("@mui/utils", "6.4.8", function() { return function() { return __webpack_require__(86293); }; }, 1);
			register("@tanstack/react-query", "4.1.0", function() { return function() { return __webpack_require__(85410); }; }, 1);
			register("@webcomponents/scoped-custom-element-registry", "0.0.10", function() { return function() { return __webpack_require__(93782); }; }, 1);
			register("axios", "1.8.3", function() { return function() { return __webpack_require__(40109); }; }, 1);
			register("clsx", "2.1.1", function() { return function() { return __webpack_require__(53048); }; }, 1);
			register("contentful", "10.8.9", function() { return function() { return __webpack_require__(25981); }; }, 1);
			register("focus-trap-react", "9.0.2", function() { return function() { return __webpack_require__(33269); }; }, 1);
			register("launchdarkly-react-client-sdk", "3.6.1", function() { return function() { return __webpack_require__(78495); }; }, 1);
			register("murmurhash", "2.0.1", function() { return function() { return __webpack_require__(8131); }; }, 1);
			register("react-cookie", "4.1.1", function() { return function() { return __webpack_require__(48987); }; }, 1);
			register("react-dom", "18.1.0", function() { return function() { return __webpack_require__(4772); }; }, 1);
			register("react-helmet-async", "1.3.0", function() { return function() { return __webpack_require__(48817); }; }, 1);
			register("react-router-dom", "6.3.0", function() { return function() { return __webpack_require__(41291); }; }, 1);
			register("react", "18.1.0", function() { return function() { return __webpack_require__(18855); }; }, 1);
			register("uuid", "8.3.2", function() { return function() { return __webpack_require__(98721); }; }, 1);
			register("web-vitals", "3.5.2", function() { return function() { return __webpack_require__(53029); }; }, 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};